var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.376055 7.50781C1.25803 8.15213 1.59396 8.24269 2.33139 9.21434C3.53724 10.8044 3.35924 11.4617 3.71792 11.7644C4.07526 12.0672 5.71474 12.3117 6.83226 10.9286C7.94979 9.54555 9.69366 5.72754 11.9287 3.43752C14.1638 1.14749 15.2077 0.48377 15.8782 0.138325C16.5487 -0.207119 14.4234 -0.133373 10.2451 3.07784C7.3395 5.31094 5.28245 8.39407 5.28245 8.39407C5.28245 8.39407 4.70161 6.70824 3.40475 5.58523C2.10788 4.46091 -1.0881 6.43784 0.376055 7.50781Z",
    fill: "url(#paint0_linear_1857_2702)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1857_2702",
    x1: -3.81806,
    y1: -2.34516,
    x2: 16.8228,
    y2: 1.17442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#826320"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7a5ce161e20c689867acd63ab8e4a9a9.svg";
export { ForwardRef as ReactComponent };